export default __webpack_public_path__ + "e74ac062f2fc87f3c2137d0b756bc972.png";